import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { MenuItem, MenuType } from '../../../../core/helpers/enum/menu.enums';

export interface NavigationItem {
    id: string;
    title: string;
    type: 'item' | 'collapse' | 'group';
    translate?: string;
    icon?: string;
    hidden?: boolean;
    url?: string;
    classes?: string;
    exactMatch?: boolean;
    external?: boolean;
    target?: boolean;
    breadcrumbs?: boolean;
    function?: any;
    badge?: {
        title?: string;
        type?: string;
    };
    children?: Navigation[];
    refreshLink?: boolean;
}

export interface Navigation extends NavigationItem {
    children?: NavigationItem[];
}

const NavigationItems = [
    {
        id: MenuItem.DashCustomer,
        title: 'Dashboard',
        type: MenuType.Item,
        icon: 'feather icon-home',
        classes: 'nav-item',
        url: '/dashboard/dash-customer',
        refreshLink: true,
    },
    {
        id: MenuItem.CaseAdd,
        title: 'Schedule Case',
        type: MenuType.Item,
        icon: 'feather icon-calendar',
        classes: 'nav-item',
        url: '/schedule/case-add',
        refreshLink: false,
    },
    {
        id: MenuItem.CaseEdit,
        title: 'Edit Case',
        type: MenuType.Item,
        icon: 'feather icon-calendar',
        classes: 'nav-item',
        url: '/schedule/case-edit/:id',
        hidden: true,
        refreshLink: false,
    },
    {
        id: MenuItem.Reports,
        title: 'Partner Reports',
        type: MenuType.Item,
        icon: 'feather icon-calendar',
        classes: 'nav-item',
        url: '/vendor/reports',
        refreshLink: false,
    },
    {
        id: MenuItem.Settings,
        title: 'Settings',
        type: MenuType.Item,
        icon: 'feather icon-settings',
        classes: 'nav-item',
        url: '/admin/settings',
        refreshLink: false,
    },
    {
        id: MenuItem.Contact,
        title: 'Contact Us',
        type: MenuType.Item,
        icon: 'feather icon-mail',
        classes: 'nav-item',
        url: '/admin/contact',
        refreshLink: false,
    },
    {
        id: MenuItem.Faq,
        title: 'FAQs',
        type: MenuType.Item,
        icon: 'feather icon-help-circle',
        classes: 'nav-item',
        url: '/admin/faq',
        refreshLink: false,
    },
];

@Injectable()
export class NavigationItem {
    public get() {
        return NavigationItems;
    }
}
